import { styled } from '@mui/material';

export const Header = styled('span')(({ theme }) => ({
  fontWeight: 600,
  fontSize: '32px',
  lineHeight: '40px',
  letterSpacing: '-0.02em',
  marginBottom: theme.spacing(4),
}));

export const Logo = styled('div')(({ theme }) => ({
  fontWeight: 600,
  fontSize: '22px',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(5),
  marginBottom: theme.spacing(2),
}));

export const FormLabel = styled('span')(({ theme }) => ({
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.palette.text.secondary,
}));
